module.exports = __webpack_public_path__ + "static/Frubana-26fa9d2a701876725165b7a017845a01.jpg";